import { brower } from '@/common//wxJs/wx-util';
import { isLogin, appLoginUtil, getWxAuth } from '@/common/js/userCtrl';
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState([
      'isMyApp',
      'appJson',
      'isPreview',
      'indexJson',
      'userInfo',
      'isMiniProgram',
    ]),
    miniProgramWxAuth() {
      return this.$appCommonH.isMiniProgramWxAuth();
    },
    isWechatMiniProgram() {
      return (
        this.isMiniProgram &&
        (brower.version.weixin || this.$appCommonH.isWechatMiniProgram())
      );
    },
  },
  methods: {
    setUserLogin: function(callback) {
      return isLogin(this.$appCommonH.getRequestParamObj().appId, status => {
        console.log(this.isMiniProgram, 'isMiniProgram');
        // 小程序内打开判定为登录状态
        if (this.isMiniProgram && !this.miniProgramWxAuth) status = true;
        this.$set(this.indexJson, 'loginStatus', status);
        if (
          this.indexJson.joinType == 2 &&
          this.isMyApp &&
          !this.userInfo.phone &&
          !location.href.includes('authKey=')
        ) {
          // 需要绑定手机号且地址栏不存在authKey，判定未未登录
          this.$set(this.indexJson, 'loginStatus', false);
        }
        return callback(this.indexJson.loginStatus);
      });
    },
    mixDoStart() {
      const allowMiniProgram = this.isWechatMiniProgram && this.miniProgramWxAuth;
      if (!window.isApp && !brower.version.weixin && !allowMiniProgram) {
        // 不是再微信环境和指定客户端内打开 不能参与抽奖
        if (this.indexJson.joinType == 1) {
          if (brower.version.weixin && this.indexJson.wechatJoin == 0) {
            this.$toast('该报名未配置微信参与权限，请下载客户端参与报名');
            return false;
          }
          this.$toast('请在微信或客户端内参与活动');
          return false;
        }
        if (this.indexJson.joinType == 2) {
          this.$toast('请在客户端内参与活动');
          return false;
        }
      }
      console.log('this.indexJson',this.indexJson)
      // if (!this.indexJson.loginStatus) {
      //   this.$toast('用户未登录');
      //   this.mixLogin();

      //   return false;
      // }

      //判断活动是否到了开始时间 || 活动已结束
      let startTime = new Date(
        this.indexJson.startTime.replace(/-/g, '/'),
      ).getTime();
      let endTime = new Date(
        this.indexJson.endTime.replace(/-/g, '/'),
      ).getTime();
      let nowTime = new Date().getTime();

      if (nowTime < startTime) {
        this.$toast('活动未到开始时间');
        return false;
      }

      if (nowTime > endTime) {
        this.$toast('活动已结束');
        return false;
      }

      if (this.indexJson.joinType == 1) {
        //登录即可参与（客户端、微信可参与）
        if (brower.version.weixin && this.indexJson.wechatJoin == 0) {
          this.$toast('该报名未配置微信参与权限，请下载客户端参与报名');
          // setTimeout(() => {
          // 	window.location.replace(process.env.VUE_APP_DOWNLOAD_URL + "#/download?appId=" + this.appJson.appId);
          // },1000);

          return false;
        }
        return true;
      }

      if (this.indexJson.joinType == 2) {
        // 绑定手机号方可参与（仅客户端参与）

        if (!this.isMyApp) {
          this.$toast('请在客户端内参与活动');
          // setTimeout(() => {
          // 	window.location.replace(process.env.VUE_APP_DOWNLOAD_URL + "#/download?appId=" + this.appJson.appId);
          // },1000);
          return false;
        }

        if (!this.userInfo.phone) {
          this.$toast('请先绑定手机号');
          return false;
        }
      }

      return true;
    },
    mixLogin() {
      if (this.isPreview) {
        return false;
      }
      if (
        this.isWechatMiniProgram &&
        this.miniProgramWxAuth &&
        this.indexJson.joinType === 1 &&
        this.indexJson.wechatJoin !== 0
      ) {
        return this.setUserLogin((status) => {
          !status && this.mixDoWxLogin();
          return true;
        });
      }
      if (!this.isMyApp && !brower.version.weixin) {
        return false;
      }
      if (this.isMyApp) {
        return this.setUserLogin(status => {
          if (status) {
            return true;
          }
          this.mixDoAppLogin();
          return true;
        });
      }
      if (brower.version.weixin && this.indexJson.joinType === 1 && this.indexJson.wechatJoin !== 0) {
        return this.setUserLogin((status) => {
          !status && this.mixDoWxLogin();
          return true
        })
      }
    },
    mixDoAppLogin() {
      let res = this.appJson;
      appLoginUtil(JSON.stringify(res));
    },
    mixDoWxLogin() {
      //获取微信授权
      getWxAuth();
    },
  },
};



// WEBPACK FOOTER //
// ./src/common/js/mixin/loginMixin.js